export default __webpack_public_path__ + "static/olga_amosova_name-0f680ca82ba2f6a8be8fd9ad91172c72.png";